import React from 'react'
import { Link } from 'react-router-dom'

export default function Barhi() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd1 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Barhi
            </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Barhi
            </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Barhi
        </h2>
        <h5 className='text-muted'>Barhi dates are usually consumed fresh; they are packed in strands or branches in 5 
KG cartoon
boxes. They are seasonal fruits that are harvested during August and September. 
They can stay fresh few weeks if stored at cool Temp.
The Barhi Date is a round shaped fruit, with golden yellowish color, a length of 2.5 
- 3.5 centimeters and a diameter of 2 to 2.5 centimeters
        </h5>

      </div>

      <hr />
      <hr />
     
      <h2 className='text-primary my-3'>Packing</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>They are packed in strands or branches in 5 KG cartoon or plastic box</h5>

        </li>
      </ul>
      <hr />
      
      <hr />
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h4 className='text-muted'>Our Barhi dates are classified into Jumbo and large according to their weight.
        </h4>
        <h5 className=' mt-3'>
        Jumbo : 15 gm & Larger
        </h5>
        <h5 className=' mt-3'>
        Large : Smaller than 12 gm /  piece
        </h5>
       
      </div>
      <hr />
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
